module.exports = __webpack_public_path__ + "img/red_004.5803e733.png";